/**
 * dialog/MbrAtrzRejectReasonDialog.tsx
 */

import React from "react";
import Button from "@/js/common/ui/Button";
import Util from "@/js/common/Util";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import FeedbackIcon from "@mui/icons-material/Feedback";

interface Props {
  mbrasAtrzDocId: string;
  setRejectModalOpen: Function;
  setDetailModalOpen: Function;
  setCallTime: Function;
}

const MbrAtrzRejectReasonDialog = ({ mbrasAtrzDocId, setRejectModalOpen, setDetailModalOpen, setCallTime }: Props) => {
  const [atrzOpnnCn, setAtrzOpnnCn] = React.useState<string>("");
  const [processing, setProcessing] = React.useState<boolean>(false);

  const goReject = () => {
    if (processing) return;

    if (Util.isEmpty(atrzOpnnCn)) {
      AppContext.openAlert({ title: "반려 사유 확인", msg: "반려 사유를 입력해주세요.", icon: "warning" });
      return;
    }

    if (Util.isEmpty(mbrasAtrzDocId)) {
      AppContext.openAlert({ title: "데이터 확인", msg: "반려 처리에 필요한 정보가 없습니다.", icon: "warning" });
      return;
    }

    AppContext.openAlert({
      title: "결재 반려",
      msg: "해당 결재 문서를 반려하시겠습니까?",
      icon: "check",
      confirmText: "반려",
      handleConfirm: () => {
        setProcessing(true);
        AppContext.showSpinner();

        Axios.dataAccess({
          url: "system/atrz/mbras/process-aprvr-mbras-rjct.do",
          methodType: "post",
          paramType: "json",
          paramData: {
            mbrasAtrzDocId: mbrasAtrzDocId,
            atrzOpnnCn: atrzOpnnCn,
          },
          onSuccessFn: () => {
            AppContext.hideSpinner();
            setProcessing(false);

            setCallTime(new Date());
            setRejectModalOpen(false);
            setDetailModalOpen(false);

            AppContext.openAlert({ title: "알림", msg: "반려 처리가 완료되었습니다.", icon: "check" });
          },
        });
      },
    });
  };

  return (
    <div className="w600 bsBdb mxw90vw">
      <div className="csP dpInBlock">
        <div className="w120 h36 dpFlx aiC jcL h30">
          <FeedbackIcon style={{ fontSize: 25, color: "#2882B7" }} />
          <span className="Pretendard-Bold fs16 fc222222 ls075 taU fwB ml5 mb5">반려 사유</span>
        </div>
      </div>

      <div className="dpFlx aiFs">
        <div className="flxg1 bsBdb">
          <textarea
            value={atrzOpnnCn}
            className="w100p h100 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs14 fc333333 ls1 bgcWhite rszN"
            maxLength={2000}
            placeholder={"반려 사유를 상세히 입력해주세요."}
            onChange={(e) => setAtrzOpnnCn(e.target.value)}
            disabled={processing}
          />
        </div>
      </div>

      <div className="dpFlx jcC mt20">
        <Button
          buttonName="취소"
          width={100}
          height={40}
          fontFamily="fm-b"
          fontSize={16}
          letterSpacing={-1}
          variant="styCancelBtn"
          borderRadius={6}
          buttonClass="dpFlx aiC jcC"
          disabled={processing}
          onClickFunc={() => {
            setRejectModalOpen(false);
            setDetailModalOpen(true);
          }}
        />
        <div className="dpFlx aiC gap10 pl10">
          <Button
            buttonName={processing ? "처리중..." : "반려 처리"}
            width={110}
            height={40}
            fontFamily="fm-b"
            fontSize={16}
            letterSpacing={-1}
            variant="styDeleteBtn"
            borderRadius={6}
            buttonClass="dpFlx aiC jcC"
            disabled={processing}
            onClickFunc={goReject}
          />
        </div>
      </div>
    </div>
  );
};

export default MbrAtrzRejectReasonDialog;